import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDoubleLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 31,
	viewBox: "0 0 31 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.2084 21.9583L7.75004 15.5L14.2084 9.04163",
		stroke: "black",
		strokeWidth: 2.58333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.25 21.9583L16.7917 15.5L23.25 9.04163",
		stroke: "black",
		strokeWidth: 2.58333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgChevronDoubleLeft;
